/**
 * Global Toast Notification System
 * Provides success, error, warning, and info toast notifications
 */

let toastContainer = null;
let toastIdCounter = 0;

// Initialize toast container
function getToastContainer() {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 12px;
      pointer-events: none;
    `;
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

// Create and show a toast
function showToast(message, type = 'info') {
  const container = getToastContainer();
  const toastId = `toast-${toastIdCounter++}`;

  // Define colors and icons by type
  const styles = {
    success: {
      bg: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
      color: '#1a1a1a',
      border: '#d4af37',
      icon: 'OK'
    },
    error: {
      bg: '#ff5252',
      color: '#fff',
      border: '#d32f2f',
      icon: 'X'
    },
    warning: {
      bg: '#ff9800',
      color: '#fff',
      border: '#f57c00',
      icon: '!'
    },
    info: {
      bg: '#2196f3',
      color: '#fff',
      border: '#1976d2',
      icon: 'i'
    }
  };

  const style = styles[type] || styles.info;

  // Create toast element
  const toast = document.createElement('div');
  toast.id = toastId;
  toast.style.cssText = `
    background: ${style.bg};
    color: ${style.color};
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 2px solid ${style.border};
    min-width: 300px;
    max-width: 400px;
    display: flex;
    align-items: center;
    gap: 12px;
    pointer-events: auto;
    cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-size: 0.95rem;
    animation: slideIn 0.3s ease-out;
    transition: opacity 0.3s ease, transform 0.3s ease;
  `;

  toast.innerHTML = `
    <div style="
      font-size: 1.5rem;
      font-weight: 700;
      flex-shrink: 0;
    ">${style.icon}</div>
    <div style="flex: 1; line-height: 1.4;">${message}</div>
    <button style="
      background: none;
      border: none;
      color: inherit;
      cursor: pointer;
      font-size: 1.2rem;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.7;
      transition: opacity 0.2s;
      flex-shrink: 0;
    " onmouseover="this.style.opacity='1'" onmouseout="this.style.opacity='0.7'">×</button>
  `;

  // Add animation keyframes if not exists
  if (!document.getElementById('toast-animations')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'toast-animations';
    styleSheet.textContent = `
      @keyframes slideIn {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(400px);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(styleSheet);
  }

  // Remove toast function
  const removeToast = () => {
    toast.style.animation = 'slideOut 0.3s ease-out';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  };

  // Close button
  const closeButton = toast.querySelector('button');
  closeButton.addEventListener('click', removeToast);

  // Add to container
  container.appendChild(toast);

  // Auto-dismiss after 4 seconds
  setTimeout(removeToast, 4000);

  return toastId;
}

// Public API
export const toast = {
  success: (message) => showToast(message, 'success'),
  error: (message) => showToast(message, 'error'),
  warning: (message) => showToast(message, 'warning'),
  info: (message) => showToast(message, 'info')
};

export default toast;
